module.exports = __webpack_public_path__ + "static/media/hospital3.f174b4e2.jpg";